import { AxiosResponse } from 'axios';
import { DeleteDirectAssignCriteriaRequest, DirectAssignCriteriaRequest, DirectAssignCriteriaSearchRequest } from '@/main/models/request';
import { DirectAssignCriteriaResponse } from '@/main/models/response/directAssignCriteriaResponse';
import { Result } from '../../models/common/resultResponse';
import { api } from '../base/api';
import { IDirectAssignCriteriaApi } from '../base';

const baseRoute: string = 'DirectAssignCriteria';

export class DirectAssignCriteriaApi extends IDirectAssignCriteriaApi {
  saveDirectAssignCriteria(
    request: DirectAssignCriteriaRequest
  ): Promise<AxiosResponse<Result<DirectAssignCriteriaResponse>>> {
    return api.post(`${baseRoute}`, request);
  }

  deleteDirectAssignCriteria(
    request: DeleteDirectAssignCriteriaRequest
  ): Promise<AxiosResponse<Result<DirectAssignCriteriaResponse>>> {
    return api.post(`${baseRoute}/delete`, request);
  }

  searchGrid(request: DirectAssignCriteriaSearchRequest ): Promise<AxiosResponse<Result<DirectAssignCriteriaResponse[]>>>{
    return api.get(`${baseRoute}/search`, {params: request});
  }
}